export enum MediaHavenPlugin {
    ADVANCED_MEDIA_PLAYER = 'ADVANCED_MEDIA_PLAYER',
    DOSSIER_TRANSFER = 'DOSSIER_TRANSFER',
    FULL_TEXT_SEARCH = 'FULL_TEXT_SEARCH',
    METABASE = 'METABASE',
    RESUMABLE_UPLOADS_MH = 'RESUMABLE_UPLOADS_MH',
    SEMANTIC_SEARCH = 'SEMANTIC_SEARCH',
    SIMILARITY_SEARCH = 'SIMILARITY_SEARCH',
    VECTOR_FIELD = 'VECTOR_FIELD',
    GOVERNANCE_ARCHIVE_OBJECTS = 'GOVERNANCE_ARCHIVE_OBJECTS',
    GENERATIVE_METADATA_MISTRAL_AI = 'GENERATIVE_METADATA_MISTRAL_AI',
    GENERATIVE_METADATA_OPEN_AI = 'GENERATIVE_METADATA_OPEN_AI',
    FACIAL_RECOGNITION_DEEP_FACE = 'FACIAL_RECOGNITION_DEEP_FACE',
    VERSION_MANAGEMENT = 'VERSION_MANAGEMENT'
}

export interface PluginObject {
    Id: string;
    Name: string;
    Category: string;
    Uri: string | null;
    DottedKey: string | null;
    CustomProperties?: Record<string, string | number>;
}

export interface ModuleObject {
    Id: string;
    Name: string;
    Plugins: PluginObject[];
    Category: ModuleCategory;
    ActiveForAllOrganisations: boolean;
}

export enum SubscriptionModules {
    STARTER_SUBSCRIPTION = 'STARTER_SUBSCRIPTION',
    BUSINESS_SUBSCRIPTION = 'BUSINESS_SUBSCRIPTION',
    ENTERPRISE_SUBSCRIPTION = 'ENTERPRISE_SUBSCRIPTION'
}

export enum ModuleCategory {
    SUBSCRIPTION = 'SUBSCRIPTION'
}
